import { Outlet, useParams } from "react-router-dom";
import Breadcrumb from "../components/breadcrumb/Breadcrumb";
import SelectedIcon from "../assets/selected-icon.png";
import { useQuery } from "react-query";
import { getPlantConfig } from "../api/config";

const CustomLayout = () => {
  const { id } = useParams();

  const { data } = useQuery({
    queryKey: [id],
    queryFn: () => {
      return getPlantConfig(id);
    },
  });

  return (
    <>
      <div className="flex items-center justify-between">
        <Breadcrumb />
        <div>
          <img src={SelectedIcon} />
          <span className="ml-2 text-tertiaryText">
            Selected Plant :{" "}
            <span className="text-primaryText font-medium">{id}</span>
          </span>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default CustomLayout;
